import { useClipboard, useToast } from '@chakra-ui/react';
import { Status } from './Status';
import { useEffect } from 'react';
import { formatDeliveryDate, formatPrice } from 'src/services/utils';
import { CopyIcon, DownloadIcon } from '@chakra-ui/icons';

export const InstallmentsRow = ({ installment }) => {
  const { onCopy, hasCopied } = useClipboard(installment.Codigo_Barras_b64);
  const toast = useToast();

  const formatDate = date => {
    if (!date) return '-';

    return formatDeliveryDate(date);
  };

  useEffect(() => {
    if (hasCopied) {
      toast({
        title: 'Código de barras copiado',
        status: 'success',
      });
    }
  }, [hasCopied, toast]);

  return (
    <tr className="text-center ">
      <td>{installment.Parcela}</td>
      <td>{formatDate(installment.Vencimento_Data)}</td>
      <td>{formatPrice(installment.Valor)}</td>
      <td>{formatDate(installment.Pagamento_Data)}</td>
      <td>
        <Status
          status={installment.Status_Pagamento}
          dueDate={installment.Vencimento_Data}
        />
      </td>
      <td>
        <div className="d-flex align-items-center justify-content-center gap-3">
          <button className="button-codebar" onClick={onCopy}>
            <CopyIcon />
            Cód. de barras
          </button>
          <a
            href={installment.url_boleto}
            target="_blank"
            rel="noreferrer noopener"
            className="button-download"
            download
          >
            <DownloadIcon />
            Baixar boleto
          </a>
        </div>
      </td>
    </tr>
  );
};
